import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { formatNum } from "../lib/utils";
import { Layers, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const STATUS = {
  active: { label: "Active", cls: "text-[#00E65B]" },
  screened_not_material: { label: "Screened — not material", cls: "text-muted-foreground" },
  not_yet_screened: { label: "Not yet screened", cls: "text-[#FFB800]" },
};

// Compact Scope 1 source-type composition card for the Environment Control Tower.
export function Scope1CompositionCard({ year }) {
  const [d, setD] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    api.get(`/ghg/scope1?year=${year}`).then((r) => setD(r.data)).catch(() => setD(null));
  }, [year]);
  if (!d) return null;
  const total = d.total_scope1_tonnes || 0;
  return (
    <div className="card-flat p-4" data-testid="env-scope1-composition">
      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2">
          <Layers className="h-4 w-4 text-accent" />
          <span className="label-eyebrow text-[10px]">Scope 1 composition — by GHG Protocol source type</span>
        </div>
        <button
          onClick={() => nav("/ghg-inventory")}
          data-testid="env-open-ghg-inventory"
          className="text-[11px] text-accent inline-flex items-center gap-1 hover:underline"
        >
          Open GHG Inventory <ArrowRight className="h-3 w-3" />
        </button>
      </div>
      <div className="space-y-2.5">
        {(d.source_types || []).map((st) => {
          const meta = STATUS[st.status] || STATUS.not_yet_screened;
          return (
            <div key={st.key} data-testid={`env-s1-type-${st.key}`}>
              <div className="flex items-center justify-between text-xs mb-1">
                <span className="font-medium">{st.label}</span>
                <span className="flex items-center gap-2">
                  <span className={`text-[10px] ${meta.cls}`}>{meta.label}</span>
                  <span className="font-mono text-muted-foreground">{formatNum(st.co2e_tonnes, { decimals: 2 })} t · {st.share_pct}%</span>
                </span>
              </div>
              <div className="h-1.5 rounded-full bg-surface-hover overflow-hidden">
                <div className="h-full rounded-full bg-accent" style={{ width: `${Math.min(100, st.share_pct)}%` }} />
              </div>
            </div>
          );
        })}
      </div>
      <div className="text-[10px] text-muted-foreground mt-3">
        Total Scope 1: <span className="font-mono">{formatNum(total, { decimals: 2 })} tCO₂e</span> · reconciles with the Control Tower Scope 1 figure.
      </div>
    </div>
  );
}
